const A = "/assets";

export const IMG = {
  logo: `${A}/brand/logo-made.png`,
  handsWater: `${A}/people/hands-water.webp`,
  girlBlue: `${A}/people/girl-blue-shirt.webp`,
  childCap: `${A}/people/child-yellow-cap.webp`,
  smilingGirls: `${A}/people/smiling-girls.webp`,
  baby: `${A}/people/baby-smile.webp`,
  twoChildren: `${A}/people/two-children.webp`,
  childBed: `${A}/activities/child-care-bed.webp`,
  kidsBanner: `${A}/activities/children-made-banner.webp`,
  volunteerChild: `${A}/activities/volunteer-with-child.webp`,
  volunteerElderly: `${A}/activities/volunteer-elderly.webp`,
  selfie: `${A}/activities/volunteers-selfie.webp`,
  drDennis: `${A}/team/dr-dennis-gonzalez.webp`,
  doctors: `${A}/team/doctors-white-coats.webp`,
  staff: `${A}/team/medical-staff.webp`,
  teamShirts: `${A}/team/made-team-tshirts.webp`,
  emblem: `${A}/team/president-emblem.webp`,
  drafting: `${A}/projects/la-romana/project-drafting.webp`,
  aerial: `${A}/projects/villa-bevilacqua/aerial-view.webp`,
  planSB: `${A}/projects/villa-bevilacqua/plan-semi-basement.webp`,
  planGF: `${A}/projects/villa-bevilacqua/plan-ground-floor.webp`,
  planFF: `${A}/projects/villa-bevilacqua/plan-first-floor.webp`,
  planSF: `${A}/projects/villa-bevilacqua/plan-second-floor.webp`,
  agrinido: `${A}/projects/villa-bevilacqua/render-3d-agrinido.webp`,
  elevations: `${A}/projects/villa-bevilacqua/elevations.webp`,
  render3d: `${A}/projects/villa-bevilacqua/render-3d-overview.webp`,
};

export const GALLERY = [
  { key: "handsWater", cat: "people" },
  { key: "smilingGirls", cat: "people" },
  { key: "girlBlue", cat: "people" },
  { key: "baby", cat: "people" },
  { key: "twoChildren", cat: "people" },
  { key: "childCap", cat: "health" },
  { key: "childBed", cat: "health" },
  { key: "drDennis", cat: "health" },
  { key: "doctors", cat: "health" },
  { key: "staff", cat: "health" },
  { key: "teamShirts", cat: "volunteers" },
  { key: "volunteerChild", cat: "volunteers" },
  { key: "volunteerElderly", cat: "volunteers" },
  { key: "selfie", cat: "volunteers" },
  { key: "kidsBanner", cat: "projects" },
  { key: "drafting", cat: "projects" },
  { key: "aerial", cat: "projects" },
  { key: "render3d", cat: "projects" },
  { key: "agrinido", cat: "projects" },
  { key: "planSB", cat: "architecture" },
  { key: "planGF", cat: "architecture" },
  { key: "planFF", cat: "architecture" },
  { key: "planSF", cat: "architecture" },
  { key: "elevations", cat: "architecture" },
];

export const OFFICIAL = {
  iban: "IT47J0615013400CC0320083494",
  ibanDisplay: "IT 47 J061 5013 400C C032 0083 494",
  bank: "Cassa di Risparmio di Fermo S.p.A.",
  holder: "MADE",
  address: "Corso Cavour 86 – 62100 Macerata",
  cf: "93078840431",
  fax: "+39 0733 231604",
  faxHref: "+390733231604",
  email: "madeonlus-italia@gmail.com",
};
